<div class="row mb-2">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Mezzanine</h4>
        <div class="row">
          <div class="col-4">
            <p class="card-text">Mezzanine Cost:</p>
          </div>
          <div class="col-8">
            <p class="card-text" align="right">
              <ng-container *ngIf="!pricingHidden; else maskBlock">
                {{ backsheet?.BudgetMezzanine.TotalSelling | currency: 'GBP' }}
              </ng-container>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <p class="card-text">Price Per Square Metre:</p>
          </div>
          <div class="col-8">
            <p class="card-text" align="right">
              <ng-container *ngIf="!pricingHidden; else maskBlock">
                {{
                  backsheet?.BudgetMezzanine.PricePerSquareMetre
                    | currency: 'GBP'
                }}
              </ng-container>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-2">
  <div *ngIf="quoteData?.GeneralData.IsFireRated" class="col-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Fire Protection</h4>
        <div class="row">
          <div class="col-4">
            <p class="card-text">Fire Protection Cost:</p>
          </div>
          <div class="col-8">
            <p class="card-text" align="right">
              <ng-container *ngIf="!pricingHidden; else maskBlock">
                {{ backsheet?.BudgetFireRating.TotalSelling | currency: 'GBP' }}
              </ng-container>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="card-text">
              {{ backsheet?.BudgetFireRating.Description }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-2">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Total Budget</h4>
        <div class="row">
          <div class="col-4 col-md-4">
            <p class="card-text">Total Cost:</p>
          </div>
          <div class="col-8">
            <p class="card-text" align="right">
              <ng-container *ngIf="!pricingHidden; else maskBlock">
                {{ backsheet?.BudgetTotal | currency: 'GBP' }} *
              </ng-container>
            </p>
          </div>
        </div>
        <div *ngIf="backsheet?.BudgetExtraOvers.length > 0">
          <hr />
          <h5 class="card-title">Extras</h5>
          <div class="row" *ngFor="let item of backsheet?.BudgetExtraOvers">
            <div class="col-4">
              <p class="card-text">{{ item.Description }}</p>
            </div>
            <div class="col-8">
              <p class="card-text" align="right">
                <ng-container *ngIf="!pricingHidden; else maskBlock">
                  {{ item.Cost | currency: 'GBP' }}
                </ng-container>
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr />
            <p class="card-text">{{ budgetDisclaimer | async }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <hr />
            <p class="card-text">
              If you are a trade distributor please click here to request access
              to our iQD quoting system.
              <button
                type="button"
                class="btn btn-primary"
                (click)="requestDistributorAccessClick()"
              >
                Request access
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="row mb-2">
  <div class="col-12">
    <ul ngbNav #tabs="ngbNav" class="nav-tabs" [(activeId)]="activeTab">
      <li ngbNavItem="3dModel">
        <a ngbNavLink (click)="switchTo3D()">3D View</a>
      </li>
      <li ngbNavItem="2dModel">
        <a ngbNavLink (click)="activeTab = '2dModel'">Layout View</a>
      </li>
    </ul>
    <div class="tab-content mt-3">
      <div *ngIf="activeTab === '2dModel'">
        <hld-floor-rendering
          [options]="options"
          [drawing]="drawing"
          [floorData]="quoteData"
        ></hld-floor-rendering>
      </div>
      <div *ngIf="activeTab === '3dModel'">
        <div #viewerContainer style="width: 100%; height: 800px"></div>
      </div>
    </div>
  </div>
</div>
<ng-template #maskBlock>Ready...</ng-template>
